export const PERMISSIONS = [
    /** Mandant konfigurieren (Name, Settings, Quellen, Queues). */
    'tenant.manage',
    /** Mitglieder + Rollen + Scopes verwalten. */
    'member.manage',
    /** Teams verwalten. */
    'team.manage',
    /** Audit-Log lesen. */
    'audit.read',
    /** Tickets lesen (ab Phase 1). */
    'ticket.read',
    /** Tickets bearbeiten/beantworten (ab Phase 1). */
    'ticket.write',
];
const ROLE_PERMISSIONS = {
    admin: PERMISSIONS,
    agent: ['ticket.read', 'ticket.write'],
    viewer: ['ticket.read'],
};
export function roleHasPermission(role, permission) {
    return ROLE_PERMISSIONS[role].includes(permission);
}
export function permissionsForRole(role) {
    return ROLE_PERMISSIONS[role];
}
/**
 * Scope-Regel (Spec 3.2): **leere Scope-Liste = Zugriff auf alles im Mandanten**.
 * Sonst muss die Queue *oder* die Quelle des Ziels gelistet sein.
 *
 * Ein Ziel ohne Queue und ohne Quelle (z. B. Mandanten-Settings) ist fuer
 * eingeschraenkte Mitglieder nicht erreichbar — das ist Absicht.
 */
export function isWithinScope(scopes, target) {
    if (scopes.length === 0)
        return true;
    const { queueId = null, sourceId = null } = target;
    if (queueId === null && sourceId === null)
        return false;
    return scopes.some((scope) => (queueId !== null && scope.queue_id === queueId) ||
        (sourceId !== null && scope.source_id === sourceId));
}
/** Alle Queue-IDs, auf die ein Mitglied eingeschraenkt ist (leer = keine Einschraenkung). */
export function scopedQueueIds(scopes) {
    return scopes.map((scope) => scope.queue_id).filter((id) => id !== null);
}
/** Alle Quellen-IDs, auf die ein Mitglied eingeschraenkt ist (leer = keine Einschraenkung). */
export function scopedSourceIds(scopes) {
    return scopes.map((scope) => scope.source_id).filter((id) => id !== null);
}
//# sourceMappingURL=permissions.js.map